// API Configuration
const config = {
  API_BASE_URL:"https://video-api-uat.brandigiops.com",//video-api-vat.brandigiops.com
};

export default config;
